<template>
  <div class="quotes-slider">
    <div class="quotes-slider__icon">
      <QuoteIcon />
    </div>
    <div class="quotes-slider__quote-wrapper">
      <div
        v-for="(quote, key) in quotes"
        :key="key"
        :class="['quotes-slider__quote', key === currentQuote && 'quotes-slider__quote--show']"
      >
        <div class="quotes-slider__quote-text">
          {{ quote.text }}
        </div>
        <div class="quotes-slider__quote-author">
          {{ quote.author }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuoteIcon from '@/assets/icons/quote.svg'

export default {
  name: 'QuotesSlider',
  components: {
    QuoteIcon: { ...QuoteIcon, name: 'QuoteIcon' },
  },
  data() {
    return {
      currentQuote: 0,
      quotes: [
        {
          text: `"I recently started my journey into the world of Cloud, came across your videos in INE... 
            I must say, it's the best and most laid out that I've seen so far for Azure!
            Thank you for making such wonderful videos."`,
          author: 'Teddy O',
        },
        {
          text: `"Passed the CCIE lab in March, much thanks to INE who played a big role in my success. 
            Both the videos and the workbook are great!"`,
          author: 'David S',
        },
        {
          text: `"Finally after 4 years study I got my CCIE number [on my] first attempt and 
            it was not achievable without Brian McGahan's training.
            He is one of the greatest instructors for CCIE in the world.
            Thanks INE and Brian McGahan"`,
          author: 'Seyed M',
        },
        {
          text: `"I've used the Advanced Technology Class Videos and the Workbook to pass my CCIE 
            Routing and Switching Exam. The explanations are simple, clear and concise. 
            Thank you for this great material!"`,
          author: 'Edward M',
        },
        {
          text: `"I have found a ton of companies that are almost exclusively requesting eLS certs. 
          That is so awesome. I am glad it is gaining traction."`,
          author: 'Jack L',
        },
      ],
    }
  },
  created() {
    this.interval = setInterval(() => {
      this.currentQuote = this.currentQuote === this.quotes.length - 1 ? 0 : this.currentQuote + 1
    }, 8000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
}
</script>

<style lang="scss" scoped>
.quotes-slider {
  background: var(--purple-gradient);
  border-radius: 10px;
  padding: 25px 20px;
  display: flex;
  align-items: center;
  @include mobile {
    justify-content: flex-end;
    background-color: var(--purple-gradient);
    background-image: url('../../assets/images/backgrounds/quote_bg.png');
    background: url('../../assets/images/backgrounds/quote_bg.png'), var(--purple-gradient);
    background-repeat: no-repeat;
    background-size: contain;
    background-position-x: 5%;
  }
  @include desktop {
    padding: 30px 50px;
  }
  &__icon {
    margin-right: 20px;
    opacity: 0.2;
    @include mobile {
      display: none;
    }
  }
  &__quote {
    &-wrapper {
      color: var(--white);
      font-family: var(--font-regular);
      font-weight: 450;
      font-size: 12px;
      line-height: 14px;
      width: 100%;
      height: 100px;
      position: relative;
      @include mobile {
        width: 78%;
        font-size: 16px;
        line-height: 24px;
      }
      @include desktop {
        width: 75%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: flex-start;
      }
    }
    opacity: 0;
    position: absolute;
    transition: 0.3s all ease-in-out;
    &--show {
      opacity: 1;
    }
    &-text {
      height: 70px;
      margin-bottom: 20px;
      @include mobile {
        height: unset;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
